import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { SqlService } from "../../Database/sql.service";
import * as XLSX from 'xlsx';
import { TestBed } from '@angular/core/testing';
import { DOCUMENT } from '@angular/common';



export type eventModel = {
  id: number,
  name: string,
}


@Component({
  selector: 'app-view-client',
  templateUrl: './view-client.component.html',
  styleUrls: ['./view-client.component.css']
})
export class ViewClientComponent implements OnInit {

  SearchValue = "";
  iRowsLoaded = 0;
  data = [{
    ID: "Loading",
    Province: "Loading",
    Area: "Loading",
    ClientCellnumber:"Loading"
  }];

  p: number = 1;
  ItemsPerPage = 20;



  constructor(private dbService: SqlService, private router: Router,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.SearchValue = "";
    this.data.splice(0);
    this.getData();
  }

  LoadMoreFields() {

    if (this.SearchValue != "") {
      this.SearchValue = "";
      this.data.splice(0);
      this.iRowsLoaded = 0;
    }
    this.getData();
  }

  async getData() {
    var formData = new FormData(); // Currently empty 
    formData.set("start", (this.iRowsLoaded).toString());
    this.iRowsLoaded += 1500;
    formData.set("end", (this.iRowsLoaded).toString());

    await (this.dbService.GetAllClientsForView(formData).subscribe((ret: any) => {
      if (ret != "false") {
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          let temp = {
            ID: elementtemp[0],
            Province: elementtemp[1],
            Area: elementtemp[2],
            ClientCellnumber: elementtemp[3]
          }
          this.data.push(temp);
        });
      } else {
        alert("Please check your connection and try again");
      }
    }));
  }


  EditData(clName: string, clAreaID: string) {
    this.router.navigate(['/EditClient',  clName,clAreaID ]);
  }


  ClearSearch() {
    this.SearchValue = "";
    this.iRowsLoaded = 0;
  }

  Add() {
    this.router.navigate(['/AddClient']);
  }

  async SearchChanged() {
    this.p = 0;


    var formData = new FormData(); // Currently empty 
    formData.set("start", (0).toString());
    formData.set("end", (this.iRowsLoaded).toString());

    formData.set("SearchValue", this.SearchValue);
    await (this.dbService.GetSimularClientsForView(formData).subscribe((ret: any) => {
      if (ret != "false") {
        this.data.splice(0);
        let a = (ret as string).split(';');
        a.splice(a.length - 1, 1);

        a.forEach(element => {
          let elementtemp = element.split(",")
          let temp = {
            ID: elementtemp[0],
            Province: elementtemp[1],
            Area: elementtemp[2],
            ClientCellnumber: elementtemp[3]
          }
          this.data.push(temp);
        });
      } else {
        alert("Please check your connection and try again");
      }
    }));
    console.log(this.data);
  }


  btnDownloadReportClickExcel() {
    /* generate worksheet */
    /* let targetTableElm = document.getElementById("tblDataExport");
    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{ sheet: "Report" });
    XLSX.writeFile(wb, `Report.xlsx`) */
    let Link = '';
    if(this.document.location.hostname.includes('admin.pactel.co.za')){
      Link = "https://admin.pactel.co.za/xdt/assets/php/";
    }else{
      Link = 'http://10.10.10.2/xdt/assets/php/';
    }
    window.open(Link + "exportAllClients.php");

  }



}

